import { render, staticRenderFns } from "./StaffCalendar.vue?vue&type=template&id=350f23b2"
import script from "./StaffCalendar.vue?vue&type=script&lang=js"
export * from "./StaffCalendar.vue?vue&type=script&lang=js"
import style0 from "./StaffCalendar.vue?vue&type=style&index=0&id=350f23b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports